// Module
var code = "<select ng-model=\"vm.model\" class=\"b-select\"> <option value=\"-1\">{{'reports.page.filter.all.projects' | translate}}</option> <option ng-repeat=\"option in vm.options track by $index\" value=\"{{option.id}}\" ng-selected=\"vm.model == option.id\"> {{option.name}} </option> </select> ";
// Exports
module.exports = code;